(() => {
  const config = JSON.parse(document.getElementById('sm-config')?.textContent || '{}');
  const root = (config.root || '/').replace(/\/?$/, '/');
  function measureHeader() {
    const header=document.querySelector('.sm-header');
    if(header) document.documentElement.style.setProperty('--sm-header-height',header.getBoundingClientRect().height+'px');
  }
  const headerObserver=new ResizeObserver(measureHeader);
  function observeHeader(){const header=document.querySelector('.sm-header');if(header)headerObserver.observe(header);measureHeader();}
  observeHeader();
  if (root !== '/') document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    if (/^\/(?:products|collections|pages|blogs|search|cart|account)(?:\/|\?|#|$)/.test(href)) link.setAttribute('href', root + href.slice(1));
  });
  const money = value => { const amount=(Number(value)/100).toFixed(2); const currency=config.currency||'EUR'; return currency==='EUR'?'€'+amount:amount+' '+({CZK:'Kč',PLN:'zł'}[currency]||currency); };
  const errorText = error => typeof error?.description === 'string' ? error.description : config.strings?.error;
  const showError = (target, text) => { if(target) { target.textContent = text; target.hidden = !text; } };
  let opener;
  function activateMobileTab(index, focus = false) {
    const drawer=document.getElementById('sm-mobile-menu');
    if(!drawer) return;
    const tabs=[...drawer.querySelectorAll('[role=tab]')];
    tabs.forEach((tab,position)=>{
      const selected=position===index;
      tab.setAttribute('aria-selected',String(selected));
      tab.tabIndex=selected?0:-1;
      const panel=document.getElementById(tab.getAttribute('aria-controls'));
      if(panel)panel.hidden=!selected;
    });
    if(focus)tabs[index]?.focus();
  }
  function openDialog(dialog, source, animate = true) { if(!dialog || dialog.open) return; opener = source; if(dialog.id === 'sm-cart-drawer') dialog.classList.toggle('sm-cart-enter', animate); if(dialog.id === 'sm-location-drawer') dialog.classList.toggle('sm-location-enter', animate); if(dialog.id === 'sm-mobile-menu'){dialog.classList.toggle('sm-menu-enter',animate);activateMobileTab(0);} dialog.showModal(); document.body.style.overflow = 'hidden'; if(dialog.id === 'sm-search') dialog.querySelector('input[type=search]')?.focus(); }
  function bindDialog(dialog) {
    dialog.addEventListener('close', () => { document.body.style.overflow = ''; opener?.focus(); });
    dialog.addEventListener('click', event => { const bounds = dialog.getBoundingClientRect(); if(event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close(); });
  }
  document.querySelectorAll('dialog').forEach(bindDialog);
  document.getElementById('sm-mobile-menu')?.addEventListener('click',event=>{
    const tab=event.target.closest('[role=tab]');
    if(!tab)return;
    activateMobileTab([...tab.parentElement.querySelectorAll('[role=tab]')].indexOf(tab));
  });
  document.getElementById('sm-mobile-menu')?.addEventListener('keydown',event=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)||!event.target.matches('[role=tab]'))return;
    event.preventDefault();
    const tabs=[...event.target.parentElement.querySelectorAll('[role=tab]')];
    const current=tabs.indexOf(event.target);
    const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(current+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
    activateMobileTab(next,true);
  });
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-open]');
    if(open) openDialog(document.getElementById(open.dataset.open),open);
    const close = event.target.closest('[data-close]');
    if(close) close.closest('dialog')?.close();
    const cartOpen = event.target.closest('[data-cart-open]');
    if(cartOpen) { event.preventDefault(); openDialog(document.getElementById('sm-cart-drawer'),cartOpen); }
    const step = event.target.closest('[data-quantity-step]');
    if(step) { const input = step.parentElement.querySelector('input'); input.value = Math.max(Number(input.min || 1),Number(input.value || 1)+Number(step.dataset.quantityStep)); input.dispatchEvent(new Event('change',{bubbles:true})); }
    const thumb = event.target.closest('[data-media-target]');
    if(thumb) { event.preventDefault(); selectMedia(thumb.closest('[data-product-section]'),thumb.dataset.mediaTarget); }
    const zoom = event.target.closest('[data-zoom]');
    if(zoom) { const dialog=zoom.closest('[data-product-section]').querySelector('.sm-zoom'); dialog.querySelector('img').src=zoom.dataset.zoom; openDialog(dialog,zoom); }
    const galleryStep = event.target.closest('[data-media-step]');
    if(galleryStep){const section=galleryStep.closest('[data-product-section]');const media=[...section.querySelectorAll('[data-media-id]')];const current=media.findIndex(item=>!item.hidden);selectMedia(section,media[(current+Number(galleryStep.dataset.mediaStep)+media.length)%media.length].dataset.mediaId);}
    const description=event.target.closest('[data-description-toggle]');
    if(description){const expanded=description.getAttribute('aria-expanded')!=='true';description.setAttribute('aria-expanded',String(expanded));document.getElementById(description.getAttribute('aria-controls')).classList.toggle('sm-description-collapsed',!expanded);description.textContent=expanded?description.dataset.less:description.dataset.more;}
    const scroll = event.target.closest('[data-scroll-step]:not(:disabled)');
    if(scroll) { const carousel=scroll.closest('.sm-featured').querySelector('[data-carousel]'); const card=carousel.querySelector('li'); if(card){const gap=parseFloat(getComputedStyle(carousel).columnGap)||0; carousel.scrollBy({left:Number(scroll.dataset.scrollStep)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});} }
  });
  document.querySelectorAll('.sm-desktop-navigation details').forEach(details => {
    const summary = details.querySelector(':scope > summary');
    let pointerType;
    summary?.addEventListener('pointerdown', event => { pointerType = event.pointerType; });
    summary?.addEventListener('click', event => {
      // Mouse hover has already opened the menu before the click arrives.
      // Keep it open; keyboard and touch retain the native details toggle.
      if(pointerType === 'mouse' && event.detail > 0) {
        event.preventDefault();
        details.open = true;
      }
    });
    details.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse') details.open=true;});
    details.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!details.contains(document.activeElement)) details.open=false;});
    details.addEventListener('focusout',e=>{if(!details.contains(e.relatedTarget)) details.open=false;});
  });
  document.addEventListener('keydown', event => {
    if(event.key!=='Escape') return;
    const open=[...document.querySelectorAll('.sm-desktop-navigation details[open]')];
    const active=open.filter(details=>details.contains(document.activeElement)).pop()||open.pop();
    if(active){event.preventDefault();active.open=false;active.querySelector(':scope > summary')?.focus();}
  });
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('.sm-desktop-navigation details[open]').forEach(details => {
      if(!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('change', event => {
    if(event.target.matches('[data-sort]')) { const url=new URL(location.href); url.searchParams.set('sort_by',event.target.value); url.searchParams.delete('page'); location.assign(url); }
    if(event.target.matches('[data-localization]')) event.target.form.submit();
  });
  function initDragScroll(container) {
    if(container.dataset.dragReady) return;
    container.dataset.dragReady = 'true';
    let start, moved = false, suppressClick = false;
    container.addEventListener('dragstart', event => event.preventDefault());
    container.addEventListener('pointerdown', event => {
      if(event.pointerType !== 'mouse' || event.button !== 0) return;
      start = {x: event.clientX, scroll: container.scrollLeft, pointer: event.pointerId};
      moved = false;
      suppressClick = false;
    });
    container.addEventListener('pointermove', event => {
      if(!start || event.pointerId !== start.pointer) return;
      const distance = event.clientX - start.x;
      if(!moved && Math.abs(distance) < 6) return;
      if(!moved) {
        moved = true;
        container.setPointerCapture(event.pointerId);
        container.classList.add('sm-dragging');
      }
      event.preventDefault();
      container.scrollLeft = start.scroll - distance;
    });
    const finish = () => {
      suppressClick = moved;
      start = null;
      container.classList.remove('sm-dragging');
      setTimeout(() => { suppressClick = false; }, 0);
    };
    container.addEventListener('pointerup', finish);
    container.addEventListener('pointercancel', finish);
    container.addEventListener('lostpointercapture', finish);
    container.addEventListener('pointerleave', () => { if(!moved) start = null; });
    container.addEventListener('click', event => {
      if(suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
  }
  document.querySelectorAll('[data-drag-scroll]').forEach(initDragScroll);
  const variantTooltip=document.createElement('div');
  variantTooltip.className='sm-variant-tooltip';
  variantTooltip.id='sm-variant-tooltip';
  variantTooltip.setAttribute('role','tooltip');
  variantTooltip.hidden=true;
  document.body.append(variantTooltip);
  function hideVariantTooltip(){variantTooltip.hidden=true;document.querySelectorAll('[aria-describedby=sm-variant-tooltip]').forEach(link=>link.removeAttribute('aria-describedby'));}
  function showVariantTooltip(link){
    variantTooltip.textContent=link.dataset.variantTitle;
    variantTooltip.hidden=false;
    link.setAttribute('aria-describedby',variantTooltip.id);
    const rect=link.getBoundingClientRect(),tip=variantTooltip.getBoundingClientRect();
    variantTooltip.style.left=Math.max(8,Math.min(innerWidth-tip.width-8,rect.left+rect.width/2-tip.width/2))+'px';
    variantTooltip.style.top=(rect.top-tip.height-9>=8?rect.top-tip.height-9:rect.bottom+9)+'px';
  }
  document.querySelectorAll('.sm-related-variants [data-variant-title]').forEach(link=>{
    link.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'||event.pointerType==='pen')showVariantTooltip(link);});
    link.addEventListener('pointerleave',hideVariantTooltip);
    link.addEventListener('focus',()=>showVariantTooltip(link));
    link.addEventListener('blur',hideVariantTooltip);
  });
  document.querySelector('.sm-related-variants-track')?.addEventListener('scroll',hideVariantTooltip,{passive:true});
  function initCarousel(carousel) {
    if(carousel.dataset.controlsReady) return;
    carousel.dataset.controlsReady='true';
    const controls=carousel.closest('.sm-featured').querySelectorAll('[data-scroll-step]');
    const update=()=>controls.forEach(button=>{
      const max=carousel.scrollWidth-carousel.clientWidth;
      button.disabled=Number(button.dataset.scrollStep)<0?carousel.scrollLeft<=1:carousel.scrollLeft>=max-1;
      button.setAttribute('aria-disabled',String(button.disabled));
    });
    carousel.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(carousel);
    update();
  }
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  function initArrowButtons(scope=document) {
    scope.querySelectorAll('.button__white,.button__black').forEach(button=>{
      if(button.classList.contains('sm-arrow-cta')||button.classList.contains('sm-quick-add')||button.closest('.sm-quick-add')||button.matches('[data-add-button]')||button.querySelector('img,svg'))return;
      let label=button.children.length===1&&button.firstElementChild.tagName==='SPAN'?button.firstElementChild:null;
      if(!label){label=document.createElement('span');while(button.firstChild)label.append(button.firstChild);button.append(label);}
      label.classList.add('sm-cta-label');button.classList.add('sm-arrow-cta');
    });
  }
  initArrowButtons();
  const timers = new WeakMap();
  function initHero(hero) {
    if(hero.dataset.ready) return; hero.dataset.ready='true';
    const slides=[...hero.querySelectorAll('[data-slide]')]; let current=0,paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const update = index => {current=(index+slides.length)%slides.length; slides.forEach((slide,i)=>slide.hidden=i!==current);hero.querySelectorAll('[data-slide-index]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===current)));};
    const stop=()=>clearInterval(timers.get(hero));
    const start=()=>{stop();if(!paused&&slides.length>1) timers.set(hero,setInterval(()=>update(current+1),7000));};
    hero.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.hasAttribute('data-slide-index'))update(Number(button.dataset.slideIndex));if(button.hasAttribute('data-slide-step'))update(current+Number(button.dataset.slideStep));if(button.hasAttribute('data-slide-pause')){paused=!paused;button.setAttribute('aria-pressed',String(paused));}start();});
    hero.addEventListener('mouseenter',stop);hero.addEventListener('mouseleave',start);hero.addEventListener('focusin',stop);hero.addEventListener('focusout',e=>{if(!hero.contains(e.relatedTarget))start();});start();
  }
  document.querySelectorAll('[data-hero]').forEach(initHero);
  function loadMedia(media) {
    if(!media) return;
    media.querySelectorAll('img[data-src]').forEach(img=>{
      img.src=img.dataset.src;
      if(img.dataset.srcset) img.srcset=img.dataset.srcset;
      delete img.dataset.src;delete img.dataset.srcset;
    });
  }
  function selectMedia(section,id) {
    const items=[...section.querySelectorAll('[data-media-id]')];
    items.forEach(media=>{
      media.hidden=media.dataset.mediaId!==String(id);
      if(media.hidden) media.querySelectorAll('video').forEach(video=>video.pause());
      else loadMedia(media);
    });
    section.querySelectorAll('[data-media-target]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.mediaTarget===String(id))));
  }
  function initProduct(section) {
    if(section.dataset.ready) return;section.dataset.ready='true';
    const product=JSON.parse(section.querySelector('[data-product-json]').textContent);const form=section.querySelector('[data-product-form]');const feeMap=JSON.parse(section.querySelector('[data-fee-variant-map]')?.textContent||'null')||{};const fees=[...form.querySelectorAll('[data-fee-label]')];function feeVariant(title){const id=feeMap[title];return product.variants.find(v=>id?String(v.id)===String(id):v.option1===title);}const select=form.querySelector('[data-variant-select]');
    if(fees.length&&select)select.closest('.sm-variant-selector').hidden=true;
    function update() {
      const labels=fees.filter(field=>field.type==='checkbox'?field.checked:field.value.trim()!=='').map(field=>field.dataset.feeLabel);
      const title=labels.length?labels.join(' + '):'Bez dodatków';
      const variant=fees.length?feeVariant(title):product.variants.find(v=>String(v.id)===String(select?.value||form.querySelector('[data-variant-id]').value));
      if(!variant) { form.querySelector('[data-add-button]').disabled=true;showError(form.querySelector('[data-form-error]'),config.strings?.error);return; }
      form.querySelector('[data-variant-id]').value=variant.id;if(select)select.value=variant.id;
      fees.forEach(field=>{const active=labels.includes(field.dataset.feeLabel);const changed=active?labels.filter(x=>x!==field.dataset.feeLabel):fees.filter(f=>labels.includes(f.dataset.feeLabel)||f===field).map(f=>f.dataset.feeLabel);const alternate=feeVariant(changed.length?changed.join(' + '):'Bez dodatków');const priceLabel=(field.closest('.sm-personalization-field')||field.closest('label'))?.querySelector('[data-fee-price]');if(alternate&&priceLabel)priceLabel.textContent='+'+money(active?variant.price-alternate.price:alternate.price-variant.price);});
      section.querySelector('[data-product-price]').textContent=money(variant.price);
      const compare=section.querySelector('[data-product-compare]');compare.hidden=!(variant.compare_at_price>variant.price);compare.textContent=money(variant.compare_at_price||0);
      const button=form.querySelector('[data-add-button]');button.disabled=!variant.available;button.querySelector('[data-add-label]').textContent=variant.available?config.strings.add:config.strings.sold;
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      if(variant.featured_media)selectMedia(section,variant.featured_media.id);
    }
    form.addEventListener('change',update);form.addEventListener('input',event=>{if(event.target.hasAttribute('data-fee-label'))update();});
    const current=product.variants.find(v=>String(v.id)===String(form.querySelector('[data-variant-id]').value));
    const currentLabel=current?(Object.keys(feeMap).find(key=>String(feeMap[key])===String(current.id))||current.option1):'';if(fees.length&&current&&currentLabel!=='Bez dodatków')fees.forEach(field=>{if(field.type==='checkbox')field.checked=currentLabel.split(' + ').includes(field.dataset.feeLabel);});
        // Load every gallery image before the first interaction so switching media cannot shift the page.
    section.querySelectorAll('[data-media-id]').forEach(loadMedia);
    const first=section.querySelector('[data-media-id]:not([hidden])');if(first)selectMedia(section,first.dataset.mediaId);update();
  }
  document.querySelectorAll('[data-product-section]').forEach(initProduct);
  async function request(url,options) { const response=await fetch(url,options);const data=await response.json();if(!response.ok)throw data;return data; }
  function replaceCart(data) {
    const drawerOpen=document.getElementById('sm-cart-drawer')?.open;
    for(const [id,html]of Object.entries(data.sections||{})) {if(!html)continue; const source=new DOMParser().parseFromString(html,'text/html').getElementById('shopify-section-'+id);const target=document.getElementById('shopify-section-'+id);if(source&&target){if(id==='cart-drawer'){const old=target.querySelector('dialog');if(old?.open)old.close();}target.innerHTML=source.innerHTML;initArrowButtons(target);target.querySelectorAll('dialog').forEach(bindDialog);}}
    document.querySelectorAll('[data-cart-count]').forEach(count=>count.textContent=data.item_count);
    if(drawerOpen)openDialog(document.getElementById('sm-cart-drawer'),opener,false);
  }
  async function refreshCart() {const sectionId=document.querySelector('.sm-cart-page')?.closest('.shopify-section')?.id.replace('shopify-section-','');const ids=['cart-drawer',...(sectionId?[sectionId]:[])];const [cart,sections]=await Promise.all([request(root+'cart.js'),request(root+'?sections='+ids.join(','))]);replaceCart({...cart,sections});}
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('[data-product-form]'))return;event.preventDefault();if(!form.reportValidity())return;
    const button=event.submitter||form.querySelector('[type=submit]');button.disabled=true;button.setAttribute('aria-busy','true');showError(form.querySelector('[data-form-error]'),'');
    try {const data=new FormData(form);data.set('sections','cart-drawer');data.set('sections_url',location.pathname);const result=await request(root+'cart/add.js',{method:'POST',body:data});replaceCart(result);await refreshCart();openDialog(document.getElementById('sm-cart-drawer'),button);document.getElementById('sm-announcement').textContent=config.strings.added;}
    catch(error){showError(form.querySelector('[data-form-error]'),errorText(error));}finally{button.disabled=false;button.removeAttribute('aria-busy');}
  });
  let cartQueue=Promise.resolve(),cartFailed=false,checkoutWaiting=false;
  const pendingLines=new Map(),submittedCartForms=new WeakSet();
  function syncPendingLines() {
    document.querySelectorAll('[data-line-key]').forEach(line=>{
      const pending=pendingLines.get(line.dataset.lineKey);
      if(pending){
        line.setAttribute('aria-busy','true');
        line.querySelector('[data-cart-quantity]').value=pending.quantity;
        line.querySelectorAll('[data-cart-step]').forEach(button=>button.disabled=pending.quantity===0||checkoutWaiting);
      } else line.removeAttribute('aria-busy');
    });
  }
  function desiredQuantity(line) {
    return pendingLines.get(line.dataset.lineKey)?.quantity??Number(line.querySelector('[data-cart-quantity]').value);
  }

  function changeLine(line,quantity) {
    if(checkoutWaiting) return;
    const key=line.dataset.lineKey;
    quantity=Math.max(0,Math.floor(Number(quantity)||0));
    const revision=(pendingLines.get(key)?.revision||0)+1;
    pendingLines.set(key,{quantity,revision});cartFailed=false;syncPendingLines();
    cartQueue=cartQueue.then(async()=>{
      const pending=pendingLines.get(key);
      if(!pending) return;
      const sent={...pending};
      try {
        const sectionId=document.querySelector('.sm-cart-page')?.closest('.shopify-section')?.id.replace('shopify-section-','');
        const data=await request(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:sent.quantity,sections:['cart-drawer',...(sectionId?[sectionId]:[])],sections_url:location.pathname})});
        if(pendingLines.get(key)?.revision===sent.revision) pendingLines.delete(key);
        replaceCart(data);syncPendingLines();
      } catch(error) {
        pendingLines.delete(key);cartFailed=true;
        try{await refreshCart();}catch{}
        syncPendingLines();
        document.querySelectorAll('.sm-cart-error').forEach(el=>showError(el,errorText(error)));
      }
    });
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-cart-step],[data-cart-remove]');
    if(!button) return;event.preventDefault();if(button.disabled||checkoutWaiting)return;
    const line=button.closest('[data-line-key]');
    changeLine(line,button.hasAttribute('data-cart-remove')?0:desiredQuantity(line)+Number(button.dataset.cartStep));
  });
  document.addEventListener('change',event=>{if(event.target.matches('[data-cart-quantity]'))changeLine(event.target.closest('[data-line-key]'),Number(event.target.value));});
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(form.matches('[data-product-form]')||submittedCartForms.has(form))return;
    if(!form.closest('.sm-cart-page,#sm-cart-drawer'))return;
    event.preventDefault();if(checkoutWaiting)return;
    const action=event.submitter?.name||'update';
    checkoutWaiting=true;
    document.querySelectorAll('[data-cart-step],[data-cart-quantity],[data-cart-remove]').forEach(control=>control.setAttribute('aria-disabled','true'));
    await cartQueue;checkoutWaiting=false;
    document.querySelectorAll('[data-cart-step],[data-cart-quantity],[data-cart-remove]').forEach(control=>control.removeAttribute('aria-disabled'));
    syncPendingLines();
    if(cartFailed)return;
    const fresh=action==='checkout'?(document.querySelector('.sm-cart-page form')||document.querySelector('#sm-cart-drawer .sm-drawer-summary form')):document.querySelector('.sm-cart-page form');
    if(!fresh)return;
    submittedCartForms.add(fresh);fresh.requestSubmit(fresh.querySelector('[name="'+action+'"]'));
  });
  document.addEventListener('click',async event=>{
    const link=event.target.closest('#sm-cart-drawer a');
    if(!link||pendingLines.size===0||!link.getAttribute('href')?.endsWith('/cart'))return;
    event.preventDefault();await cartQueue;if(!cartFailed)location.assign(link.href);
  });
  document.addEventListener('focusout',event=>{if(event.target.id==='CartNote')cartQueue=cartQueue.then(()=>request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:event.target.value})})).catch(()=>{});});
  document.querySelectorAll('product-recommendations').forEach(element=>{const observer=new IntersectionObserver(async entries=>{if(!entries[0].isIntersecting)return;observer.disconnect();try{const response=await fetch(element.dataset.url);const doc=new DOMParser().parseFromString(await response.text(),'text/html');const replacement=doc.querySelector('product-recommendations');if(replacement?.querySelector('.sm-product-card')){element.innerHTML=replacement.innerHTML;initArrowButtons(element);}}catch{}},{rootMargin:'300px'});observer.observe(element);});
  document.addEventListener('shopify:section:load',event=>{initArrowButtons(event.target);observeHeader();event.target.querySelectorAll('[data-hero]').forEach(initHero);event.target.querySelectorAll('[data-carousel]').forEach(initCarousel);event.target.querySelectorAll('[data-drag-scroll]').forEach(initDragScroll);event.target.querySelectorAll('[data-product-section]').forEach(initProduct);event.target.querySelectorAll('dialog').forEach(bindDialog);});
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hero]').forEach(hero=>clearInterval(timers.get(hero))));
})();

